import { configureStore } from '@reduxjs/toolkit'
import uiReducer from './slices/uiSlice'
import contentReducer from './slices/contentSlice'

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    content: contentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
